<div class="wrapper" [ngClass]="{ 'show-viewer': !loading }" style="opacity: 0;">
  <!-- <button mat-mini-fab matTooltip="Close" [ngClass]="{ 'become-fixed': makePosFixed }"  matTooltipPosition="below" class="close-icon" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button> -->
  <a mat-mini-fab class="download-btn" [ngClass]="{ 'become-fixed': makePosFixed }" matTooltip="Download" matTooltipPosition="below"
    [href]="'https://drive.fevertreefinance.co.za/file/fetch/' + reference" target="_blank">
    <mat-icon>download</mat-icon>
  </a>
  <br>
  <br>
  <pdf-viewer [fit-to-page]="true" *ngIf="reference" (after-load-complete)="loading = false;"
    [src]="'https://drive.fevertreefinance.co.za/file/fetch/' + reference"  [render-text]="true"
    style="display: block;"></pdf-viewer>
    <br>
    <br>
</div>
<div class="loading-overlay" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
